<template>
    <div class="mb-3 form-group formly-input">
        <label>{{field.templateOptions.label}}</label>
        <datepicker
                v-model="model[field.key]"
                :name="field.key"
                :monday-first="true"
                :bootstrap-styling="true"
                initial-view="year"
                @selected="this.onChange"
                :placeholder="field.templateOptions.placeholder"
                :language="sk"
        ></datepicker>
        <error-display :form="form" :field="field.key"></error-display>
    </div>
</template>

<script>
  import baseField from 'vue-formly-bootstrap/src/fields/baseField';
  import {sk} from 'vuejs-datepicker/dist/locale'

  export default {
    name: 'DateField',
    mixins: [baseField],
    components: {
      Datepicker: () => import('vuejs-datepicker')
    },
    data () {
      return {
        sk: sk
      }
    }
  };
</script>

<style scoped>

</style>
